module.exports = __webpack_public_path__ + "static/img/content2.7a523cae.png";